import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/ai/ai-details/{aiRequestId}']['GET'];
type Input = ThisApi['params'];

const getAiDetails = async ({ aiRequestId }: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/ai/ai-details/{aiRequestId}', { aiRequestId });
  const data = await noodleApiClient.get(path);
  return data.data;
};

export default getAiDetails;
